import { takeEvery, fork, put, all, call } from 'redux-saga/effects'

import fetch from './../../../fetch'
import {
  baseURL,
  commonHeaders,
} from './../../../../../Containers/Confiq/index'

import {
  GET_SERVICE,
  GET_SERVICE_SUCCESS,
  GET_SERVICE_ERROR,
} from './../../../actionType'

function* getService({ payload }) {
  try {
    const response = yield call(fetch, {
      url: `${baseURL}/parse/classes/golfbookings/${payload.id}`,
      method: 'GET',
      headers: { ...commonHeaders },
    })

    console.log('mytestingResponse', response, response?.error)
    if (response?.error === undefined) {
      yield put({ type: GET_SERVICE_SUCCESS, payload: response })
    } else {
      yield put({ type: GET_SERVICE_ERROR, payload: response.error })
    }
  } catch (error) {
    yield put({ type: GET_SERVICE_ERROR, payload: error })
  }
}

export function* watchGetService() {
  yield takeEvery(GET_SERVICE, getService)
}

function* getServiceSaga() {
  yield all([fork(watchGetService)])
}

export default getServiceSaga
